<script setup lang="ts">
import { useGetMe } from "@/auth/useMe";
import { usePermissions } from "@/auth/usePermissions";
import { useRouter } from "vue-router";

const router = useRouter();
const { me, getMeStatus } = useGetMe({
  onUnauthorizedError: () => router.push({ name: "login" }),
});
const { canAccess } = usePermissions(me);
</script>

<template>
  <template v-if="getMeStatus === 'success' && me !== undefined">
    <slot :me="me" :can-access="canAccess" />
  </template>
</template>
